/**
 * @returns {SharedWorker}
 * @internal
 */
export const createHierarchicalLayoutWorker = () => new SharedWorker(new URL('./HierarchicalLayout.worker.js', import.meta.url), {
    type: 'module',
    name: 'HierarchicalLayout'
});
